module.exports = __webpack_public_path__ + "img/vn-dejun3.8b087952.png";